import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(
    private toastr: ToastrService,
    private translateService: TranslateService
  ) { }

  showSuccess(message, title) {
      this.toastr.success(message, title);
  }

  showError(message, title) {
      this.toastr.error(message, title);
  }

  showInfo(message, title) {
      this.toastr.info(message, title);
  }

  showWarning(message, title) {
      this.toastr.warning(message, title);
  }

  handleError(error: any, message?: string) {
    const errors = this.getErrorMessages(error);
    
    this.translateService.get(['GENERAL.ERROR', message, ...errors]).subscribe(res => {
      if(errors.length <= 0) {
        const customErrors = error.error.field;
        customErrors.forEach(error => {
          this.showError(error.errCode, res['GENERAL.ERROR']);
        });
        return;
      }
      errors.forEach(element => {
        this.showError(res[element], res['GENERAL.ERROR']);
      });
    });
  }

  handleSuccess(message: string) {
    this.translateService.get(['GENERAL.SUCCESS', message]).subscribe(res => {
      this.showSuccess(res[message], res['GENERAL.SUCCESS']);
    });
  }

  handleMessages(successMessage: string, errorMessage?: string) {
    return tap(
      () => this.handleSuccess(successMessage),
      (error) => this.handleError(error, errorMessage)
    );
  }

  private getErrorMessages(error: any) {
    if (!!error.error.global) {
      return error.error.global.map(item => `ERRORS.${item}`);
    }

    return ['ERRORS.UNKNOWNN'];
  }
}
